import axios from 'axios';
import { isArray } from 'lodash-es';
import {
  WarehouseOptionItem,
  WarehouseOptionParams,
  WarehousePositionBody,
  WarehousePositionItemDto,
  WarehousePositionPayload,
} from './modify-position.dto';

class ModifyPositionService {
  async getWarehousePositions(
    params: WarehousePositionPayload,
  ): Promise<WarehousePositionItemDto[]> {
    const { data } = await axios.get('api/skus/warehouses/position', {
      params,
    });
    return [data];
  }

  async putWarehousePosition(params: WarehousePositionBody) {
    await axios.put('api/skus/warehouses/position', params);
  }

  /**
   * 获取仓库option
   * @param is_data_permissions 默认1:不按数据权限展示   2:按数据权限展示
   */
  async getWarehouseOptions(
    params: WarehouseOptionParams,
  ): Promise<WarehouseOptionItem[]> {
    const { data } = await axios.get<WarehouseOptionItem[]>(
      `api/warehouses/options`,
      {
        params,
      },
    );

    return data;
  }

  /**
   * 扫码sku可能是json字符串，需要做parse后取第一项
   * @param sku sku🐴
   * @returns 转换后的 sku 码
   * @example ['sku123', 'xxx'] => 'sku123'
   */
  parseSku(sku: string) {
    try {
      const res = JSON.parse(sku);
      return isArray(res) ? res[0] : res;
    } catch (error) {
      return sku;
    }
  }
}

const modifyPositionService = new ModifyPositionService();

export default modifyPositionService;
